import React from "react";
import IMTaskModule from "../modules/imtask/IMTaskModule";

/**
 * AdminIMTask — pagina host per il modulo IMTask CRM.
 * Route protetta ``/admin/imtask`` (adminOnly) definita in App.js.
 */
export default function AdminIMTask() {
  return <IMTaskModule />;
}
